// import * as React, from "react";
import React, {useEffect, useState, useRef} from "react";
import { useLocation } from "react-router-dom";

// React Bootstrap
import {Modal, Tab, Nav, Offcanvas} from 'react-bootstrap';



// Import Components
import Header from "../components/HeaderComponent";

// Import Images
import preregisterBg1 from '../assets/images/preregister-bg-2.png'

// Import Icons
import {Link} from "react-router-dom";
import crossIcon from "../assets/images/icons/cross-gray-icon.svg";
import CoinSelectDropdown from "../components/CoinSelectDropdown";
import walletIcon from "../assets/images/icons/wallet-gray-icon.svg";
import SelectDropdown from "../components/SelectDropdown";



function PreRegistrationPage() {
    const location = useLocation();
    const [preRegistrationShow, setPreRegistrationShow] = useState(true);

    // Assets Withdraw Modal Start
    const onPreRegistrationClose = () => {
        setPreRegistrationShow(true);
    }
    const onPreRegistrationShow = () => {
        setPreRegistrationShow(true);
    }
    // Assets Withdraw Modal End


    useEffect(() => {
        // Add the class when the page is loaded
        if (location.pathname === "/pre-registration") {
            document.body.classList.add("pre-registration-page");
        }

        // Cleanup: Remove the class when the component unmounts or route changes
        return () => {
            document.body.classList.remove("pre-registration-page");
        };
    }, [location.pathname]);

    return (
        <div className='home-page'>
            <section className="sec-registration">
                <div className="img-wrapper">
                    <img src={preregisterBg1} alt="img"/>
                </div>
            </section>

            {/* Assets Withdraw Modal Start */}
            <Modal size="lg"
                   aria-labelledby="contained-modal-title-vcenter"
                   centered className="modal pre-registration-modal" show={preRegistrationShow} onHide={onPreRegistrationClose}>
                <Modal.Body>
                    <div className="pre-registration-wrapper">
                        <div className="pre-registration-card">
                            <h3>Exclusive Pre-Registration Open for Crypto Custody, Cross Border payment Payment & OTC Fiat On/Off-Ramp Product</h3>
                            <p>Doru.co, a fintech company in partnership with regulated players, is launching a limited-access crypto custody, ISO20022 compliant Cross border payment and OTC fiat on/off-ramp Product. Designed for individuals and businesses, our service ensures a secure, seamless, and efficient way to manage digital assets.</p>
                            <p className="p w-600">Be among the first select clients to experience:</p>
                            <ul className="feature-list">
                                <li>Secure Crypto Custody: Your digital assets safeguarded with cutting-edge technology.</li>
                                <li>ISO2022 Compliant Cross Border Payment</li>
                                <li>OTC Fiat On/Off-Ramp: Effortless conversions between crypto and fiat with competitive rates.</li>
                            </ul>
                            <p>Spaces are limited, and pre-registration is open for a short time only. Apply now to secure your place!</p>
                        </div>
                        <div className="registration-footer">
                            <ul className="btn-list">
                                <li><a href="https://forms.gle/MQFsaQH8RW53Y5Rg7" target="_blank" className="btn-style">Pre-Register Now</a></li>
                            </ul>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Assets Withdraw Modal End */}
        </div>
    )
}

export default PreRegistrationPage
